import { useEffect, useState } from "react";
import Input from "./components/Input";

const MAX_METER_READING_DIGITS = 8;

export default function MeterReportItem(props) {
  const [date, setDate] = useState(new Date(props.date));
  const [reading, setReading] = useState(props.reading);
  const [note, setNote] = useState(props.note);

  // Watch the fields for external changes.
  useEffect(() => setDate(new Date(props.date)), [props.date]);
  useEffect(() => setReading(props.reading), [props.reading]);
  useEffect(() => setNote(props.note), [props.date]);

  const prefix = props.id;

  useEffect(() => {
    props.checkDirty({ date, reading, note, id: props.id });
  }, [date, reading, note])

  return (
    <div className="flex flex-col gap-4 [&:not(:last-child)]:border-b border-black pb-4 mb-2">
      <h3 className="text-lg font-bold">{props.label} ({props.name})</h3>
      <div className="flex gap-4 items-start">
        <Input
          name={`${prefix}-date`}
          type="date"
          formErrors={props.formProblems}
          label="Date"
          value={date}
          onChange={(value) => {
            setDate(value);
          }}
          required
        />
        <Input
          name={`${prefix}-reading`}
          type="number"
          formErrors={props.formProblems}
          label="Reading"
          description="Enter Reading from flowmeter face, don’t include decimal point"
          value={reading}
          onKeyDown={(e) => {
            if (e.key === '.' || e.key === 'e') {
              e.preventDefault();
            }
          }}
          onChange={(_, originalValue) => {
            const i = props.formProblems.findIndex((p) => p.field === `${prefix}-reading`);
            if (i >= 0) {
              props.formProblems.splice(i, 1);
            }
            const value = originalValue.substring(0, MAX_METER_READING_DIGITS);
            setReading(value ? Number(value) : "");
          }}
          required
        />
      </div>
      <Input
        type="textarea"
        name={`${prefix}-note`}
        formErrors={props.formProblems}
        label="Note"
        value={note}
        onChange={setNote}
      />
    </div>
  );
}
